import SimpleStore from '../../store/SimpleStore';
import {
  getLocalStorage,
  setCookie,
  setLocalStorage
} from '../browserStorageHandler';
import { USER_TYPE_COOKIE } from '../constants/cookieConstants';
import { HTTP_HEADER_KEYS } from '../constants/HttpMethodsConstants';
import { USER_TYPE } from '../constants/localStorageConstants';
import { UserTypes } from '../constants/stringConstants';

/**
 * This function sets user type in local stroage. It accepts a string param from UserTypes enum.
 * @param userType: valid user types like guest, register, premium. Remember to use UserTypes enum to
 * pass the value.
 */
export const setUserTypeInLS = (userType: string) => {
  setLocalStorage(USER_TYPE, userType);
  setCookie(USER_TYPE_COOKIE, userType);
  SimpleStore.set(HTTP_HEADER_KEYS.X_USER_TYPE, userType);
};

/**
 * This function reads user type key from local storage and retuns it. If key is not present, it returns
 * guest by default.
 * @returns: User type by reading from localstorage. Or GUEST by default
 */
export const getUserTypeFromLS = () => {
  const userType = getLocalStorage(USER_TYPE);
  if (userType) {
    return userType;
  }
  return UserTypes.GUEST;
};
